<div class="container topbar-container" [ngStyle]="background">
    <div *ngIf="profile" class="name-container my-2">
        <div class="font-header-login-details">{{ 'SI_NAVBAR_WELCOME' | translate}},
            {{ profile.firstName }}
            {{ profile.lastName }}
        </div>
        <div class="font-header-login-datetime">{{ 'LABEL_LAST_LOGIN' | translate }}:
            {{ profile.dateAndTimeLastLogin }}
        </div>
    </div>

    <div *ngIf="!hideSidebar" class="topbar-menu-list">
      <ng-container *ngIf="this.srvPermitted.menuDesktopTop$ | async">
        <ng-container *ngFor="let section of this.srvPermitted.menuDesktopTop$.getValue()!.sections | keyvalue: compareFn">
          <div class="topbar-menu-list-item">
            <button mat-stroked-button class="tight-button font-header-menutop-activity-group highlight-menu" [disableRipple]="true"
              [matMenuTriggerFor]="menu" #trigger="matMenuTrigger" [class.active]="trigger.menuOpen">
              <div class="px-3 highlight-menu-text">{{ section.value.title | translate }}</div>
              <div class="highlight-menu-underline"></div>
            </button>
            <mat-menu #menu="matMenu">
              <ng-container *ngIf="section.value.groups.length == 1">
                <a mat-menu-item *ngFor="let activity of section.value.groups[0].activities" [routerLink]="activity.path" class="font-header-menutop-activity-item highlight-submenu">
                  <span class="pb-1 highlight-submenu-text">{{ activity.label | translate }}</span>
                </a>
              </ng-container>
              <ng-container *ngIf="section.value.groups.length > 1">
                <mat-accordion>
                  <mat-expansion-panel *ngFor="let group of section.value.groups">
                    <mat-expansion-panel-header (click)="$event.stopPropagation()">
                      <mat-panel-title class="me-0">
                        <span class="font-header-menutop-activity-group-folded">{{group.title | translate}}</span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
    
                    <mat-nav-list>
                      <a mat-list-item *ngFor="let activity of group.activities" [routerLink]="activity.path" class="highlight-compressed-menu">
                        <span class="font-header-menutop-activity-item highlight-compressed-menu-text">{{ activity.label | translate }}</span>
                      </a>
                    </mat-nav-list>
    
                  </mat-expansion-panel>
                </mat-accordion>
              </ng-container>
              
            </mat-menu>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div *ngIf="hideSidebar" class="topbar-hide-container w-100">
        <button mat-icon-button class="tight-button icon-center" [matMenuTriggerFor]="compressedMenu" [ngStyle]="background">
            <mat-icon svgIcon="farBars" class="icon-white"></mat-icon>
        </button>
        
        <mat-menu #compressedMenu="matMenu">
          <mat-accordion>
            <ng-container *ngIf="this.srvPermitted.menuDesktop$ | async">
              <ng-container *ngFor="let section of this.srvPermitted.menuDesktop$.getValue()!.sections | keyvalue: compareFn">
                <mat-expansion-panel *ngFor="let group of section.value.groups">
                  <mat-expansion-panel-header (click)="$event.stopPropagation()">
                      <mat-panel-title class="me-0">
                          <span class="font-header-menutop-activity-group-folded">{{group.title | translate}}</span>
                      </mat-panel-title>
                  </mat-expansion-panel-header>
  
                  <mat-nav-list [ngStyle]="background">
                      <a mat-list-item *ngFor="let activity of group.activities" [routerLink]="activity.path" [ngStyle]="background" class="highlight-compressed-menu">
                          <span class="font-header-menutop-activity-item-folded highlight-compressed-menu-text">{{ activity.label | translate }}</span>
                      </a>
                  </mat-nav-list>
  
                </mat-expansion-panel>
              </ng-container>
            </ng-container>
          </mat-accordion>
        </mat-menu>
        
    </div>
</div>

